import script from "./CartNormal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartNormal.vue?vue&type=script&setup=true&lang=ts"

import "./CartNormal.vue?vue&type=style&index=0&id=03c8552c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c8552c"]])

export default __exports__